import { Operation, split } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'

import { createHttpLink } from './httpLink'
import { createSubscriptionLink } from './subscriptionLink'

type TCreateSubscriptionLinkOptions = FirstParam<typeof createSubscriptionLink>
type TCreateHttpLinkOptions = FirstParam<typeof createHttpLink>

export type TNetworkLinkOptions = TCreateHttpLinkOptions & TCreateSubscriptionLinkOptions

/**
 * creates an Apollo GQL client network communication link
 * which is a combination of HttpLink (for Queries & Mutations) and SubscriptionLink (for Subscriptions)
 * ! this is a terminating link and it should be placed at the end of the link array
 * https://www.apollographql.com/docs/react/api/link/introduction#the-terminating-link
 */
export const createNetworkLink = (options: TNetworkLinkOptions) => {
  const { actionCableClient, ...httpLinkOptions } = options

  const httpLink = createHttpLink(httpLinkOptions)
  const subLink = createSubscriptionLink({ actionCableClient })

  const networkLink = split(isSubscription, subLink, httpLink)

  return networkLink
}

// helper fnc to decide whether the Operation is a Subscription or not (Query or Mutation)
const isSubscription = ({ query }: Operation) => {
  const definition = getMainDefinition(query)
  return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
}
